
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/helpHome/styles.scss.css.virtualfile';
        module.exports = {"blocks":"_blocks_1kel4_7","list":"_list_1kel4_15"};